import { ZegoUIKitPrebuilt } from "@zegocloud/zego-uikit-prebuilt";

const APP_ID = 770845152;
const SERVER_SECRET = 'bbcdc764e4835e8b6cdcd59a8a9eb549';

// Both patient and doctor MUST use the same roomId.
// Use your booking/appointment id so it's unique per consultation.
export const getRoomId = (bookingId) => `consultation_${bookingId}`;

/**
 * DEV: generates token in the browser (exposes the secret, not safe for production).
 * PROD: replace with a call to your backend that returns a token04
 *       and use ZegoUIKitPrebuilt.generateKitTokenForProduction(APP_ID, token, roomId, userId, userName)
 */
export const buildKitToken = async ({ roomId, userId, userName }) => {
  if (!APP_ID || !SERVER_SECRET) {
    throw new Error("Zego APP_ID / SERVER_SECRET missing in .env");
  }
  return ZegoUIKitPrebuilt.generateKitTokenForTest(
    APP_ID,
    SERVER_SECRET,
    roomId,
    String(userId),
    userName
  );
};

export const ZEGO_ROLE_PREFIX = { patient: "patient_", doctor: "doctor_" };